<template>
	<v-app id="login-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<strong>ورود به پنل کاربری</strong>
				&nbsp;&nbsp;
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="11" sm="8" md="7" lg="6" xl="4">
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="!forgotPassword">
								<v-img class="white--text align-end" height="200px" src="/login-banner.jpg?v=1">
									<v-card-title style="background-color: #434343c7;padding: 10px;">
										نام کاربری و کلمه عبور خود را وارد کنید
									</v-card-title>
								</v-img>
								<div class="text-center  mt-5" v-if="(!isCloud || customerCode) && loginMode !== 'roles' && checkActivePart('loginOtp')">
									<v-btn-toggle v-model="loginMode" color="deep-purple accent-5">
										<v-btn value="static" class="mx-2 rounded-xl">
											<v-icon right class="ml-2">mdi-account-key-outline</v-icon>
											ورود با رمز ثابت
										</v-btn>

										<v-btn value="sms" class="mx-2 rounded-xl">
											<v-icon right class="ml-2">mdi-message-text-lock-outline</v-icon>
											ورود با رمز پیامکی
										</v-btn>
									</v-btn-toggle>
								</div>
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="loginMode === 'static'">
										<v-form ref="formLogin" class="mx-4" lazy-validation @submit.prevent="handleLogin">
											<v-row>
												<v-col cols="12" class="mt-4">
													<v-text-field ref="username" class="left-input" v-model="user.username" :label="`نام کاربری ${userNameHint}`" persistent-hint :hint="!isCloud ? 'مشتریان عزیز از کد ملی به عنوان نام کاربری استفاده کنید.' : ''" :error-messages="errorMessages" :rules="[() => user.username != '' || 'نام کاربری را وارد کنید']" focused />
												</v-col>
												<v-col cols="12">
													<v-text-field ref="password" class="left-input" v-model="user.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => !!user.password || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور" @click:append="show1 = !show1" />
												</v-col>
											</v-row>
											<v-row class="mx-0 ">
												<v-col cols="4" class="px-0">
													<v-text-field label="کد امنیتی" maxLength="4" v-model="loginCaptcha">
													</v-text-field>
												</v-col>
												<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
													<v-btn class="mr-1" color="secondary" small fab icon @click="refreshLoginCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
													<CaptchaImage ref="loginCaptcha" :codeType="['0']" style="direction: ltr;" />
												</v-col>
											</v-row>
											<div class="form-group">
												<div v-if="message" class="alert alert-danger" role="alert">
													{{ message }}
												</div>
											</div>
											<v-card-actions>
												<v-spacer />
												<v-btn ref="submit" color="secondary" dark :loading="loading" type="submit">
													ورود
												</v-btn>
												<v-spacer />
											</v-card-actions>
											<div class="text-center my-3">
												<div class="text-center">
													<v-btn class="mx-auto mb-0" text @click="forgotPassword = true">
														فراموشی کلمه عبور؟
													</v-btn>
												</div>
												<div>
													<v-btn class="mx-auto mb-2" text @click="goToRegister" v-if="showRegisterBtn">
														در سایت عضو نیستید؟ ثبت نام کنید
													</v-btn>
												</div>
											</div>
										</v-form>
									</div>
								</v-slide-x-transition>
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="loginMode === 'sms'">
										<v-form ref="formOTPLogin" class="mx-4" lazy-validation @submit.prevent="handleOtpLogin()">
											<v-row class="my-4">
												<v-col cols="12" class="mt-4 d-flex">
													<v-text-field ref="mobile" class="center-input" type="tel" maxlength="11" v-model="user.mobile" @keyup.enter="sendOTP()" label="شماره موبایل" persistent-hint :error-messages="errorMessages" :rules="[() => user.mobile != '' || 'شماره موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" focused autofocus />
													<div style="width:140px;padding-top: 20px;padding-right: 10px;">
														<v-btn v-if="sendCodeVisible" class="mr-1" color="secondary" :loading="otpLoading" small @click="sendOTP()">دریافت رمز پیامکی</v-btn>
														<Countdown class="black--text text-center fs-h3" @finish="countDownFinished" ref="countdown" />
													</div>
												</v-col>
												<v-col cols="12">
													<div class="text-center mb-2"><small>رمز پیامکی را اینجا وارد کنید:</small></div>
													<div class="d-flex justify-center flex-row-reverse otp-container">
														<v-text-field class="code-inputs center-input" outlined v-model="smsCode[0]" dense hide-details maxLength="1" type="tel" tabindex="1" @input="focusOnNext()" />
														<v-text-field class="code-inputs center-input" outlined v-model="smsCode[1]" dense hide-details maxLength="1" type="tel" tabindex="2" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
														<v-text-field class="code-inputs center-input" outlined v-model="smsCode[2]" dense hide-details maxLength="1" type="tel" tabindex="3" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
														<v-text-field class="code-inputs center-input" outlined v-model="smsCode[3]" dense hide-details maxLength="1" type="tel" tabindex="4" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
														<v-text-field class="code-inputs center-input" outlined v-model="smsCode[4]" dense hide-details maxLength="1" type="tel" tabindex="5" @keyup.backspace="focusOnPrevios()" />
													</div>
												</v-col>
											</v-row>
											<div class="mb-4">
												<v-alert v-if="message" type="error" outlined>
													{{ message }}
												</v-alert>
												<div v-if="message" class="text-red text-center" role="alert">
												</div>
											</div>
											<v-card-actions class="">
												<v-spacer />
												<v-btn ref="submit" color="secondary" dark :loading="loading" type="submit">
													ورود
												</v-btn>
												<v-spacer />
											</v-card-actions>
											<div class="text-center my-3">
												<div class="text-center">
													<v-btn class="mx-auto mb-0" text @click="forgotPassword = true">
														فراموشی کلمه عبور؟
													</v-btn>
												</div>
												<div>
													<v-btn class="mx-auto mb-2" text @click="goToRegister" v-if="showRegisterBtn">
														در سایت عضو نیستید؟ ثبت نام کنید
													</v-btn>
												</div>
											</div>
										</v-form>
									</div>
								</v-slide-x-transition>
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="loginMode === 'roles'" class="pa-4">
										<div class="mb-3 text-center">لطفا نوع پنل کاربری خود را انتخاب کنید:</div>
										<div class="d-flex flex-column justify-center align-center">
											<v-btn color="secondary" :loading="loading" style="width:150px" class="my-3 rounded-xl" outlined v-for="role in roles" :key="role" @click="handleOtpLogin(role)">
												{{ roleNames[role.toLowerCase()] || role }}
											</v-btn>
											<v-alert v-if="message" type="error" dense small outlined>
												{{ message }}
											</v-alert>
											<v-btn style="width:150px" color="info" @click="loginMode = 'sms'" small text>بازگشت به صفحه قبل</v-btn>
										</div>
									</div>
								</v-slide-x-transition>
							</div>
						</v-slide-x-transition>
					</v-card>
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="forgotPassword">
								<v-img class="white--text align-end" height="200px" :src="require('@/assets/docks.jpg')">
									<v-card-title style="background-color: #434343c7;padding: 10px;">نام کاربری جهت بازیابی کلمه عبور را
										وارد کنید</v-card-title>
								</v-img>
								<v-form ref="formForgot" class="mx-2" lazy-validation @submit.prevent="handleForgot">
									<v-row>
										<v-col cols="12" class="mt-4">
											<v-text-field ref="username" v-model="forgot.username" label="نام کاربری" :error-messages="errorMessages" :rules="[(value) => value != '' || 'نام کاربری را وارد کنید']" focused />
										</v-col>
									</v-row>
									<v-row class="mx-0 ">
										<v-col cols="4" class="px-0">
											<v-text-field label="کد امنیتی" maxLength="4" v-model="forgotCaptcha">
											</v-text-field>
										</v-col>
										<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
											<v-btn class="mr-1" color="secondary" small fab icon @click="refreshForgotCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
											<CaptchaImage ref="forgotCaptcha" :codeType="['0']" style="direction: ltr;" />
										</v-col>
									</v-row>
									<div class="form-group">
										<div v-if="forgotMessage" class="alert alert-danger" role="alert">
											{{ forgotMessage }}
										</div>
									</div>
									<v-card-actions>
										<v-spacer />
										<v-btn color="blue" dark :loading="loading" type="submit">
											دریافت کلمه عبور
										</v-btn>
										<v-spacer />
									</v-card-actions>
									<div class="text-center my-3">
										<v-btn class="mx-auto mb-2" text @click="forgotPassword = false">بازگشت به ورود</v-btn>
									</div>
								</v-form>
							</div>
						</v-slide-x-transition>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import api from '@/util/app-api'
	import CaptchaImage from '@/components/app/CaptchaImage.vue'
	import { get } from 'vuex-pathify'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'Login',
		components: {
			CaptchaImage: CaptchaImage
		},
		data() {
			return {
				loginCaptcha: '',
				forgotCaptcha: '',
				forgotPassword: false,
				smsCode: [null, null, null, null, null],
				forgot: { username: '' },
				user: { username: '', password: '', email: '', mobile: '' },
				loading: false,
				otpLoading: false,
				message: '',
				forgotMessage: '',
				errorMessages: '',
				show1: false,
				loginMode: 'static',
				sendCodeVisible: true,
				customerCode: 0,
				roles: [],
				roleNames: { member: 'مشتری', agent: 'نماینده', admin: 'مدیر سیستم', marketer: 'بازاریاب', customermarketer: 'بازاریاب' }
			}
		},
		computed: {
			loggedIn() {
				return this.$store.state.auth.status.loggedIn
			},
			...get('siteConfig', [
				'longTitle', 'isCloud'
			]),
			showRegisterBtn() {
				return !this.isCloud
			},
			userNameHint() {
				return this.$route.query.from == 'home' ? '(شماره موبایل)' : ''
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			// this.$refs.submit.$el.focus()
			// this.$refs.password.$el.querySelector('input').click()
		},
		methods: {
			handleLogin() {
				if (!this.$refs.formLogin.validate()) { return }
				if (!this.$refs.loginCaptcha.verify(this.loginCaptcha)) {
					this.message = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.message = ''
				}
				this.loading = true
				if (this.user.username && this.user.password) {
					this.$store.dispatch('auth/login', this.user).then((to) => {
						this.$router.push(to).catch(() => { })
					}).catch(error => {
						this.loading = false
						this.message = error.message || error.toString()
					})
				}
			},
			handleForgot() {
				if (!this.$refs.formForgot.validate()) { return }
				if (!this.$refs.forgotCaptcha.verify(this.forgotCaptcha)) {
					this.forgotMessage = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.forgotMessage = ''
				}
				this.loading = true
				api.post('account/forgot/' + this.forgot.username, null, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.forgotMessage = 'کلمه عبور جدید برای شما پیامک شد.'
					})
					.catch(err => {
						this.forgotMessage = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			refreshLoginCaptcha() {
				this.$refs.loginCaptcha.refresh()
			},
			refreshForgotCaptcha() {
				this.$refs.forgotCaptcha.refresh()
			},
			goToRegister() {
				this.$router.push({ name: 'Register', params: { customerCode: this.$route.params.customerCode || 0 } }).catch(() => { })
			},
			focusOnNext() {
				var currInput = document.activeElement
				if (!currInput.value)
					return
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					for (var i = 0; i < inputs.length; i++) {
						if (inputs[i] == currInput) {
							var next = inputs[i + 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
			focusOnPrevios() {
				var currInput = document.activeElement
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					for (var i = inputs.length - 1; i > 0; i--) {
						if (inputs[i] == currInput) {
							var next = inputs[i - 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
			isPhoneNumberValid() {
				return this.user.mobile && (/^((?!(0))[0-9]{10})$/g.test(this.user.mobile) || /^0[0-9]\d{9}$/g.test(this.user.mobile))
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.user.mobile) {
					this.message = 'شماره موبایل وارد نشده است.'
					return
				}
				this.otpLoading = true
				let data = {
					mobile: this.user.mobile,
					customerCode: this.customerCode
				}
				api.post('account/SendLoginOTP', data, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						this.message = err.message
					})
					.finally(() => {
						this.otpLoading = false
					})
			},
			handleOtpLogin(role = null) {
				this.message = ''
				if (!this.$refs.formOTPLogin.validate()) { return }
				if (!this.smsCode.every(x => !!x || x == 0)) { this.message = 'رمز تاییدیه پیامکی وارد نشده است'; return }
				this.loading = true
				this.user.customerCode = this.customerCode
				this.user.otpCode = this.smsCode.join('')
				this.user.role = role
				this.$store.dispatch('auth/otpLogin', this.user).then((res) => {
					this.loading = false
					if (res.to) {
						this.$router.push(res.to).catch(() => { })
					}
					else if (res.roles) {
						this.roles = res.roles
						this.loginMode = 'roles'
					}
				}).catch(error => {
					this.loading = false
					this.message = error.message || error.toString()
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.otp-container {
		column-gap: 10px;

		.code-inputs {
			width: 45px;
			max-width: 45px;
			height: 45px;
			max-height: 45px;
			margin: 0;
			text-align: center;

			input {
				text-align: center;
			}
		}
	}
</style>
